import React, { Component } from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import changeCase from 'change-case'

export default class GridItem extends Component {
  state = {
    isHover: false,
  }

  addHover = () => {
    this.setState({ isHover: true })
  }

  removeHover = () => {
    this.setState({ isHover: false })
  }

  render() {
    const { imageMap, link, className } = this.props
    const { isHover } = this.state
    let title = link
    const snakeLink = changeCase.headerCase(link).toLowerCase()

    switch (link) {
      case 'progetto':
        title = 'Il Progetto'
        break
      case 'sottoprogetti':
        title = 'Sotto-progetti'
        break
      case 'pubblicazioni':
        title = 'Pubblicazioni e risorse'
        break
      case 'gruppoDiRicerca':
        title = 'Gruppo di ricerca'
        break
    }

    return (
      <Link
        to={`/${snakeLink}`}
        className={`LinksGrid__Item ${className || ''}`}
        onMouseEnter={this.addHover}
        onMouseLeave={this.removeHover}
        onClick={this.removeHover}
      >
        {/* Immagine normale */}
        <Img
          critical
          sizes={imageMap[link].node.sizes}
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: isHover ? -1 : 0,
          }}
        />
        {/* Immagine rollover */}
        <Img
          fadeIn={false}
          sizes={imageMap[`${link}Hover`].node.sizes}
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: isHover ? 0 : -1,
          }}
        />
        <div className="LinksGrid__Item__Title">{`${title}`}</div>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/grid-item/index.js